module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "FRONT.IV"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.8"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0005#rFRONT.IV"
    }
  }, [_vm._v("IV. Theological Themes")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("The themes of obedience, disobedience, holiness, and the presence of God are keys to understanding the book of Numbers. For purposes of thematic discussion it will be helpful to break the book into three constituent parts: Orientation ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:1–10:10")]), _vm._v("), Disorientation ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10:11–22:1")]), _vm._v("), and New Orientation ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("22:1–36:13")]), _vm._v(").﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.8.0019",
      "id": "FN.8.0019r"
    }
  }, [_vm._v("1")]), _vm._v("﻿ The travel sections ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10:11–12:16")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20:1–22:1")]), _vm._v(") are transitional.")]), _vm._v(" "), _c('p', [_vm._v("The opening section ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:1–10:10")]), _vm._v(") stresses the importance of exact obedience to Yahweh in the census (cf. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:54")]), _vm._v("), the camp ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("2:34")]), _vm._v("), the presentation of offerings (ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("7")]), _vm._v("), and Israel’s encampment/decampment ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("9:23")]), _vm._v("). Yahweh’s will is that Israel be "), _c('i', [_vm._v("oriented")]), _vm._v(" toward him as a holy people, separated from the uncleanness of the rest of the world, as seen in the separation of the Levites (chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3–4")]), _vm._v(") and the Nazirites (ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("6")]), _vm._v(") from the people and the priests from the Levites (ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("8")]), _vm._v("). Yahweh’s camp is also a place where no uncleanness (e.g., leprosy) is allowed ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("5:1–4")]), _vm._v("). Wrongs that are not atoned for ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("5:5–10")]), _vm._v(") and suspicions between husbands and wives ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("5:11–31")]), _vm._v(") also bring uncleanness to Yahweh’s holy people. The first section concludes with the recognition that uncleanness will in fact exist, but it also shows Yahweh’s gracious provision that feasts (e.g., Passover) may be postponed until cleanness is regained ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("9:1–14")]), _vm._v("). The camp as ideally constituted will have the numinous presence of Yahweh with his people as they move toward their destiny in Canaan ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("9:15–22")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("After the command to depart is given ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10:11–13")]), _vm._v("), the people leave the sacred mountain in exact obedience to the instructions in ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("2")]), _vm._v(" ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10:14–36")]), _vm._v("). This obedience to Yahweh is the way for Israel to maintain holiness and orientation. What happens next, however, is almost instantaneous complaining and "), _c('i', [_vm._v("dis")]), _vm._v("obedience. In three scenes the complaints involve the people in general, the rabble (the non-Israelites who had come along with them; cf. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 12:38")]), _vm._v("), and even the family of Moses itself. Each disobedience brings immediate judgment from Yahweh ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("11:1")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("12:9–12")]), _vm._v("). "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.9"
    }
  }), _vm._v("In this transitional section the paradigm of the central section of the book is set: painful disorientation for God’s people.")]), _vm._v(" "), _c('p', [_vm._v("The story of the spies (chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("13–14")]), _vm._v(") is extremely important to understand the disorientation of the Israelites. In these chapters the people decide that Moses and Aaron (God’s chosen leaders) are not to be trusted to lead. Then, through fear, the people decide that, in spite of God’s promise to give them Canaan, they are not strong enough for the task, and, further, that they need to select a new leader who will take them back to Egypt. In effect they choose to go back to a time before Yahweh had revealed himself to them at Sinai, when they were choosing “other gods,” and God sees this act as rebellion. God’s response to this rebellion is a curse on the entire generation. The old generation had been afraid to go forward; now they would not go forward. They had been afraid that their children would die in the wilderness; now, "), _c('i', [_vm._v("they")]), _vm._v(" would die there. Not one of the Exodus generation over twenty years of age (except Caleb and Joshua) would go into Canaan. It was not possible to go back to Egypt. Rebellion against Yahweh would, instead, lead to forty years’ wandering in the wilderness, making no progress toward the goal of God’s promise of land in Canaan ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("14:20–35")]), _vm._v("), but it could not lead back to Egypt. The people were God’s in spite of their rebellion.")]), _vm._v(" "), _c('p', [_vm._v("In ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("15")]), _vm._v(" God shows his continued care for Israel by giving supplementary laws for cereal and drink offerings, first fruits, and purification offerings. God is still working with the people in spite of their rebellion, but that the supposedly holy people are by this time truly disoriented is seen in the further rebellions of Korah, Dathan, and Abiram (ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("16")]), _vm._v("). These men are not satisfied with the leadership as God had given it; they want more power. The result is tragic and fatal ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("16:31–35")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("17:6–15")]), _vm._v(" [Eng. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("16:41–50")]), _vm._v("]). Yahweh’s presence brings awful judgment in the narratives of the spies and of Korah, in contrast to the cloudy pillar, which was to provide leadership on the way to Canaan in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:1–10:10")]), _vm._v(". In spite of the judgment, however, God affirms that the people are his (chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("17–18")]), _vm._v("). Once again he appoints the tribe of Levi in general and the family of Aaron in particular to stand as leaders of the people and intercessors between God and Israel ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("17:17–28")]), _vm._v(" [Eng. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1–13")]), _vm._v("]). Also, in response to the people’s terror, God changes the duties of both the priests and the Levites so as to protect the people from future outbreaks of divine wrath. God moves to work with his people in their disorientation in order to reorient their lives.")]), _vm._v(" "), _c('p', [_vm._v("In "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20:1–22:1")]), _vm._v(" the people begin moving back toward Canaan, and so toward a new orientation to God’s will for them. At the beginning of this transitional section is the note of Miriam’s death ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20:1")]), _vm._v("), followed "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.10"
    }
  }), _vm._v("immediately by a situation in which both Moses and Aaron commit a fatal sin ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20:2–13")]), _vm._v("). Following the announcement of the impending doom of the Exodus leaders Moses and Aaron, the situation begins to move toward a better day. The king of Edom denies a request to pass through his land, but Israel suffers no defeat ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20:14–21")]), _vm._v("). When Aaron the high priest dies at Mt. Hor ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20:22–29")]), _vm._v("), it is the end of an era.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.10.0020",
      "id": "FN.10.0020r"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', [_vm._v("After his death Israel gains a victory at Hormah ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("21:1–3")]), _vm._v(") in contrast to the old and painful defeat there in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("14:39–45")]), _vm._v(" at the beginning of the period of disorientation. The incident of the fiery serpents shows that, although the people continue to complain and rebel, intercession is now quick and effective, and the presence of God is both for judgment ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("21:6")]), _vm._v(") and for salvation ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("21:8–9")]), _vm._v("). The travel itinerary ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20:10–20")]), _vm._v(") sees even the wilderness wandering as making progress toward a goal, that is, God is involved in the process to bring about his purposes even in the face of human rebellion. Further evidences that the people are moving toward a new orientation are the two victories over Sihon the Amorite ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("21:21–32")]), _vm._v(") and Og of Bashan ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("21:33–35")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("As the Israelites arrive on the plains of Moab ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("22:1")]), _vm._v("), they are on the threshold of a new orientation. The dominant theme in the last section of the book becomes the blessing of God in Canaan. The paradigm for this blessing is set by a non-Israelite seer named Balaam, who is hired to curse the Israelites by Balak of Moab (with the complicity of the Midianites), but instead blesses them four times ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("22:7–12")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("13–26")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("23:27–24:13")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("24:14–19")]), _vm._v(") and outlines God’s promise for the future of this people ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("24:20–25")]), _vm._v(").﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.10.0021",
      "id": "FN.10.0021r"
    }
  }, [_vm._v("3")]), _vm._v("﻿ It has been apparent in chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("13–19")]), _vm._v(" that Israel can bring a curse upon themselves, but in spite of that curse, if the people obey, the future will lay open to them. None of their enemies could curse them, for Yahweh was intent on blessing a newly oriented Israel.")]), _vm._v(" "), _c('p', [_vm._v("The incident concerning the Baal of Peor (ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("25")]), _vm._v(") is the last disorientation narrative in the book. Because of idolatry, once again, God’s presence becomes a consuming fire in the form of a plague ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("25:1b–5")]), _vm._v("). The plague is stemmed when Phinehas acts in zeal to defend Yahweh’s honor ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("25:6–9")]), _vm._v("). The response of God is the future establishment of Phinehas’s priestly line ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("25:10–15")]), _vm._v("), thus showing, again, the future orientation of the whole last section of Numbers.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.11"
    }
  }), _vm._v("Evidently the plague killed the last of the cursed Exodus generation. It was now time for a new beginning in earnest. A new census ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26:1–51")]), _vm._v(") reasserts the people’s exact obedience to Yahweh’s command through Moses. This is not, however, a simple return to the old orientation, but a "), _c('i', [_vm._v("new")]), _vm._v(" orientation because it is a "), _c('i', [_vm._v("new")]), _vm._v(" generation.")]), _vm._v(" "), _c('p', [_vm._v("From this point on the vast majority of material concerns the new land. The matters of daughters’ inheritance rights ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("27:1–11")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("36:1–13")]), _vm._v("), of the commissioning of Joshua as leader for the new day ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("27:12–23")]), _vm._v("), of the calendar of feasts for regular celebration of Yahweh’s presence in the new land ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("28:1–29:40")]), _vm._v("), of vows ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("30:1–16")]), _vm._v("), of the division of certain parts of the Transjordan ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("32:1–42")]), _vm._v(") and Canaan proper ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("34:1–49")]), _vm._v("), of the ideal boundaries of Canaan ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("34:1–29")]), _vm._v("), of the Levites’ cities ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("35:1–8")]), _vm._v("), and of the cities of refuge ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("35:9–34")]), _vm._v(") all point toward the good future in the land that Yahweh will give. Punishment of Midian ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("31:1–54")]), _vm._v(") and destruction of the other Canaanites ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("33:50–56")]), _vm._v(") are reaffirmations of the importance of orientation toward Yahweh and Yahweh alone. The long list of campsites ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("33:1–49")]), _vm._v(") puts the whole journey from Egypt to Canaan under the direction of Yahweh, who has guided even through the rebellions of Israel.")]), _vm._v(" "), _c('p', [_vm._v("The obvious fact is that Numbers ends on the plains of Moab with Moses alive. The death of Moses is postponed until "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Deut. 34")]), _vm._v(", which serves to link Numbers with Deuteronomy. The story of Numbers is a story without a conclusion. The future is open to God’s people, but it is unsure. It will depend on whether his people maintain their orientation toward him and him alone. Every new generation of God’s people faces the same uncertainty, but also has the same promise of blessing.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.11.0022",
      "id": "FN.11.0022r"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', [_vm._v("Minor themes in the book of Numbers will be discussed as they are met in the commentary proper (e.g., the theme of leadership in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("11:4–35")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("16:1–17:28")]), _vm._v(" [Eng. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("16:1–17:13")]), _vm._v("]; etc.).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2355a5c7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eer-nicot04nu-0012.vue
// module id = 87
// module chunks = 0